import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs';
import { StatusChange } from '../model/enum';

@Injectable({
    providedIn: 'root'
})
export class RealTimeUpdateService {
 subscribeToUpdates(gridApi: any, liveData: any): void {
    let rowData: any[] = [];
    gridApi?.api?.forEachNode((node) => rowData.push(node.data));

    const response = liveData?.response;

    const highlightRow = (id: any) => {
      setTimeout(() => {
        const index = rowData.findIndex(row => row.id === id);
        if (index !== -1) {
          rowData[index].highlight = false;
          const rowNode = gridApi.api.getDisplayedRowAtIndex(index);
          rowNode?.setData(rowData[index]);
        }
      }, 1000);
    };

    const highlightWrapper = (id: any) => {
      setTimeout(() => {
        const index = gridApi.findIndex((row: any) => row.id === id);
        if (index !== -1) {
          gridApi[index].highlight = false;
        }
      }, 1000);
    };

    const updateRowById = (id: any) => {
      const index = rowData.findIndex(item => item.id === id);
      if (index !== -1) {
        const isExpandable = rowData[index]?.isExpandable;
        rowData[index] = { ...response, highlight: true, isExpandable };
      }
    };

    

    const deleteByIds = (ids: any[]) => {
      rowData = rowData.filter(item => !ids.includes(item.id));
    };


    switch (liveData.StatusChange) {
    
      case StatusChange.CompanyCreated:
      case StatusChange.VendorCreated:
      case StatusChange.ContactCreated:
      case StatusChange.PartsCreated:
      case StatusChange.VendorContactCreated:
      case StatusChange.CodeCrosswalkCreated:
      case StatusChange.LeadCreated:
      case StatusChange.ProspectCreated:
      case StatusChange.CustomerCreated:
      rowData.unshift({ ...response, highlight: true });
        gridApi?.api.setRowData(rowData);
        
       //highlightRow(response?.id);
        break;

      
      case StatusChange.CompanyUpdated:
      case StatusChange.VendorUpdated:
      case StatusChange.ContactUpdated:
      case StatusChange.PartsUpdated:
      case StatusChange.VendorContactUpdated:
      case StatusChange.CodeCrosswalkUpdated:
      case StatusChange.LeadUpdated:
      case StatusChange.ProspectUpdated:
      case StatusChange.CustomerUpdated:
        updateRowById(response?.id);
        gridApi.api.setRowData(rowData);
        //highlightRow(response?.id);
        break;

     
      case StatusChange.ActivityCreated:
      //case StatusChange.UserCreated:
      case StatusChange.UserRoleCreated: {
        const data = gridApi;
        const exists = data.some((item: any) => item.id === response?.id);
        if (!exists) {
          data.push({ ...response, highlight: true });
          if (data.length > 1) {
            const lastRow = data.pop();
            data.unshift(lastRow);
          }
          const updatedData = data.map((item: any, index: number) => ({
            ...item,
            rowNo: index + 1,
          }));
          gridApi?.api?.setRowData(updatedData);
          highlightWrapper(response?.id);
        }
        break;
      }

      
      case StatusChange.ActivityUpdated:
      //case StatusChange.UserUpdated:
      case StatusChange.UserRoleUpdated: {
        const updateKey = response?.userId || response?.id;
        const targetData = gridApi;
        const idx = targetData.findIndex((item: any) =>
          item?.userId === updateKey || item?.id === updateKey
        );
        if (idx !== -1) {
          const isExpandable = targetData[idx]?.isExpandable;
          targetData[idx] = { ...response, highlight: true, isExpandable };
          gridApi?.api?.setRowData(targetData);
          highlightWrapper(response?.id);
        }
        break;
      }

     
      case StatusChange.CompanyDeleted:
      case StatusChange.ContactDeleted:
      case StatusChange.PartsDeleted:
      case StatusChange.CodeCrosswalkDeleted:
      case StatusChange.VendorDeleted:
      case StatusChange.VendorContactDeleted:
      case StatusChange.LeadDeleted:
      case StatusChange.ProspectDeleted:
      case StatusChange.CustomerDeleted:
        deleteByIds(response); // expects array of ids
        gridApi?.api?.setRowData(rowData);
        break;

     
      default:
        gridApi?.api?.setRowData(rowData);
        break;
    }
  }
}

